import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FilesService } from '../../../../services/files.service';
import { FileSystemNode } from '../../../../model/FileSystemNode';
import { DialogService } from '../../../../services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { NodeOperationResult } from '../../../../model/NodeOperationResult';

@Component({
  selector: 'app-node',
  imports: [CommonModule],
  templateUrl: './node.component.html',
  styleUrl: './node.component.scss'
})
export class NodeComponent {

  @Input("node") node: FileSystemNode = {} as FileSystemNode;
  @Output("selectedChildren") selectedChildren = new EventEmitter<NodeOperationResult | boolean>();

  private dialogService = inject(DialogService);
  constructor(private service: FilesService, private translate: TranslateService) { }

  openNode(node: FileSystemNode): void {
    if (node.isDirectory) {
      node.opened = !node.opened;
      if (!node.openedOnce) {
        this.service.getDirectory(node.path).subscribe(addedNode => {
          this.selectedChildren.emit({ node: node, addedNode: addedNode, type: 'added' });
        });
        node.openedOnce = true;
      }
    }
  }

  isNodeOpened(node: FileSystemNode): boolean {
    return node.opened || node.isRoot;
  }

  deleteNode(node: FileSystemNode): void {
    this.dialogService.confirm({
      title: node.isFile ? this.translate.instant('nodo.eliminar.file') : this.translate.instant('nodo.eliminar.directory'),
      message: this.translate.instant('nodo.eliminar', { name: node.name }),
      confirmText: 'Eliminar',
      cancelText: 'Cancelar'
    }).subscribe(confirmed => {
      if (confirmed) {
        this.selectedChildren.emit({ node: node, addedNode: undefined, type: 'deleted' });
      }
    });
  }

  editNode(node: FileSystemNode): void {
    this.dialogService.editItem(node).subscribe(confirmed => {
      if (confirmed) {
        this.selectedChildren.emit({ node: node, addedNode: undefined, type: 'edited' });
      }
    });
  }

  extractExtension(path: string): string {
    const parts = path.split('.');
    let extension: string | undefined = '';
    if (parts.length > 1) {
      extension = parts.pop();
    }
    return extension || '';
  }

  isExtensionImage(extension: string): boolean {
    return ['png', 'jpg', 'jpeg'].indexOf(extension) > -1;
  }

  isImage(node: FileSystemNode): boolean {
    const extension = this.extractExtension(node.path);
    return node.isFile && this.isExtensionImage(extension);
  }

  isPdf(node: FileSystemNode): boolean {
    const extension = this.extractExtension(node.path);
    return node.isFile && extension === 'pdf';
  }

  agregarFileODirectorio(node: FileSystemNode) {
    this.dialogService.agregarFileODirectorioSelector(node).subscribe(result => {
      if (result) {
        this.selectedChildren.emit(result);
      }
    });
  }

  //encadena los eventos hasta el file.component
  childSelectedChildren(data: NodeOperationResult | boolean): void {
    this.selectedChildren.emit(data);
  }

}